import React__default from 'react';
import classnames from 'classnames';
import { Modal } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { useConfiguratorContext } from '../../Context/ConfiguratorContext.js';
import { usePrivateSteppingContext } from '../../Context/PrivateSteppingContext.js';
import { getStepsList, getCurrentStepIndex } from '../../state/selectors.internal.js';
import { pushDataLayerEvent } from '../../utils/data-layer.js';

const ConfiguratorModal = ({ 'data-t': dataT , children , className , isOpen , preventVerticalScroll ,  })=>{
    const { getLabel  } = useIntl();
    const { goToPreviousStep , onModalClose  } = useConfiguratorContext();
    const { configuratorId , selectorProps  } = usePrivateSteppingContext();
    const steps = useSelector((s)=>getStepsList(s, selectorProps)
    );
    const currentStepIndex = useSelector((s)=>getCurrentStepIndex(s, selectorProps)
    );
    const isFirstStep = currentStepIndex === 0;
    const previousSteps = steps.slice(0, currentStepIndex);
    const allPreviousStepsSkipped = previousSteps.every((s)=>s.skip
    );
    const handleBackClick = React__default.useCallback(()=>{
        pushDataLayerEvent({
            steps,
            currentStepIndex,
            eventType: 'rx_back_click',
            eventCategory: configuratorId === 'rxSun' ? 'rx_sunglasses' : 'rx_glasses'
        });
        if (isFirstStep || allPreviousStepsSkipped) {
            if (onModalClose) {
                onModalClose();
            }
        } else {
            goToPreviousStep();
        }
    }, [
        steps,
        currentStepIndex,
        configuratorId,
        isFirstStep,
        allPreviousStepsSkipped,
        onModalClose,
        goToPreviousStep, 
    ]);
    const handleOnModalClose = ()=>{
        pushDataLayerEvent({
            steps,
            currentStepIndex,
            eventType: 'rx_exit_click',
            eventCategory: configuratorId === 'rxSun' ? 'rx_sunglasses' : 'rx_glasses'
        });
        if (onModalClose) {
            onModalClose();
        }
    };
    const backLabel = getLabel('common.actions.previous');
    const secondaryIconOptions = {
        'aria-label': backLabel,
        name: 'chevron-left',
        onClick: handleBackClick,
        label: backLabel
    };
    return /*#__PURE__*/ React__default.createElement(Modal, {
        "data-t": dataT,
        preventVerticalScroll: preventVerticalScroll,
        className: classnames('configurator-modal', className),
        secondaryIconOptions: secondaryIconOptions,
        onModalClose: handleOnModalClose,
        isOpen: isOpen,
        isFullScreen: true,
        showIcon: true
    }, children);
};

export { ConfiguratorModal };
//# sourceMappingURL=ConfiguratorModal.js.map
